import React from 'react';
import {
  ConfigCatProvider,
  useFeatureFlag,
  PollingMode,
  createConsoleLogger,
  LogLevel,
} from 'configcat-react';
import AppConstants from '../constants/appConstants';

// Provider do ConfigCat
export const ConfigCatContextProvider = ({ children }) => {
  return (
    <ConfigCatProvider
      sdkKey={AppConstants.ConfigCatSDKKey}
      pollingMode={PollingMode.AutoPoll}
      options={{
        pollIntervalSeconds: 60, // intervalo de atualização em segundos
        logger: createConsoleLogger(
          process.env.NODE_ENV === 'production' ? LogLevel.Error : LogLevel.Debug
        ),
      }}
    >
      {children}
    </ConfigCatProvider>
  );
};

// Hook helper para usar feature flags do ConfigCat
// Exemplo de uso: const { value, loading } = useConfigCatFlag('minha-feature-flag');
export const useConfigCatFlag = (flagKey, defaultValue = false) => {
  const { value, loading } = useFeatureFlag(flagKey, defaultValue);
  return { value, loading };
};
